import { useEffect, useRef } from "react";

export default function useClickOutside(ref, fun, ignoredSelectors = []) {
  const callbackRef = useRef(fun);
  
  // Update callback ref when it changes
  useEffect(() => {
    callbackRef.current = fun;
  }, [fun]);

  useEffect(() => {
    const listener = (e) => {
      if (
        ignoredSelectors.length &&
        ignoredSelectors.some((selector) => e.target.closest(selector))
      ) {
        return;
      }
      if (!ref.current || ref.current.contains(e.target)) {
        return;
      }
      callbackRef.current();
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, ignoredSelectors]);
}
